import { Button } from 'react-bootstrap';
import SignatureOffCanvas from '../OffCanvas/SignatureOffCanvas/SignatureOffCanvas';

function Signature({
  show,
  name,
  title,
  nameColor,
  signature,
  nameFontSize,
  post,
  postColor,
  postFontSize,
  //
  handleSave,
  handleShow,
  handleClose
}) {
  return (
    <>
      <div onClick={handleShow}>
        {name ? (
          <div
            style={{
              textAlign: 'center',
              marginTop: '3rem',
              minWidth: '230px'
            }}>
            <div style={{ borderBottom: '5px dotted #333', marginBottom: '1rem' }}></div>
            <div
              style={{
                fontSize: `${nameFontSize}px`,
                color: nameColor
              }}>
              {name}
            </div>
            <div
              style={{
                fontSize: `${postFontSize}px`,
                color: postColor,
                maxWidth: '200px',
                margin: 'auto'
              }}>
              {post}
            </div>
          </div>
        ) : (
          <div className="hidden-in-print">
            <Button>Click to add Signatory</Button>
          </div>
        )}
      </div>

      <SignatureOffCanvas
        title={title}
        show={show}
        initialValue={signature}
        handleClose={handleClose}
        handleSave={handleSave}
      />
    </>
  );
}

export default Signature;
